import { getCLS, getFID, getLCP, getFCP, getTTFB } from 'web-vitals';
import logger from './logger';
import { DatadogCustomMetrics } from '../../api/common/datadog-custom-metrics.constants';
import performanceEvents from '../../helpers/constants/performanceEvents';

export function getCoreWebVitals(
  message,
  logType = DatadogCustomMetrics.WEBVITALS,
) {
  getLCP((lcp) => {
    if (lcp && lcp.value) {
      logger.info('LargestContentfulPaint', {
        event: 'LargestContentfulPaint',
        requestRoute: message,
        millis: lcp.value,
        logType,
        method: performanceEvents.CARDS,
      });
    }
  });
  getFID((fid) => {
    if (fid && fid.value) {
      logger.info('FirstInputDelay', {
        event: 'FirstInputDelay',
        requestRoute: message,
        millis: fid.value,
        logType,
        method: performanceEvents.CARDS,
      });
    }
  });
  getCLS((cls) => {
    if (cls && cls.value) {
      logger.info('CumulativeLayoutShift', {
        event: 'CumulativeLayoutShift',
        requestRoute: message,
        millis: cls.value,
        logType,
        method: performanceEvents.CARDS,
      });
    }
  });
}

export function getOtherWebVitals(
  message,
  logType = DatadogCustomMetrics.WEBVITALS,
) {
  getFCP((fcp) => {
    if (fcp && fcp.value) {
      logger.info('FirstContentfulPaint', {
        event: 'FirstContentfulPaint',
        requestRoute: message,
        millis: fcp.value,
        logType,
        method: performanceEvents.CARDS,
      });
    }
  });
  getTTFB((ttfb) => {
    if (ttfb && ttfb.value) {
      logger.info('TimeToFirstByte', {
        event: 'TimeToFirstByte',
        requestRoute: message,
        millis: ttfb.value,
        logType,
        method: performanceEvents.CARDS,
      });
    }
  });
}
